export enum InputIsValid{
    NotSet,
    Valid,
    Invalid
}